import { Link } from "react-router-dom";
import DocUpdateIcon from "../../assets/DocUpdateIcon.svg";
import Forbes2xImg from "../../assets/Forbes2x.png";
import Badge500Img from "../../assets/500.webp";
import SOC2LogoImg from "../../assets/SOC2-Logo.png";
import GPTWBadgeImg from "../../assets/Impiricus_US_English_2025_Certification_Badge_large.png";
import FortuneAccoladeImg from "../../assets/Fortune-Accolade-GPTW-Health-Care.png";
import HipaaSealImage from "../HipaaSeal/HipaaSeal";
import "./WPFooter.css";

const WPFooter = () => {
  return (
    <footer className="wp-footer">
      <div className="wp-footer__container">
        {/* ===== Top section ===== */}
        <div className="wp-footer__top">
          {/* Left column: Logo, links, social */}
          <div className="wp-footer__top-left">
            <a
              href="https://www.docupdate.io/"
              className="wp-footer__logo"
              aria-label="DocUpdate Home"
            >
              <img
                src={DocUpdateIcon}
                alt="DocUpdate"
                className="wp-footer__logo-img"
              />
            </a>

            <nav className="wp-footer__nav" aria-label="Footer">
              <a
                href="https://www.docupdate.io/manage-preferences/"
                className="wp-footer__nav-link"
              >
                Manage Preferences
              </a>
              <a
                href="https://www.docupdate.io/#faq"
                className="wp-footer__nav-link"
              >
                Help
              </a>
              <a
                href="https://www.docupdate.io/privacy-policy/"
                className="wp-footer__nav-link"
              >
                Privacy Policy
              </a>
            </nav>

            {/* Social icons — exact SVGs from WP source */}
            <div className="wp-footer__social">
              <a
                href="https://www.facebook.com/GetDocUpdate"
                target="_blank"
                rel="noopener noreferrer"
                className="wp-footer__social-link"
                aria-label="Facebook"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M16 0C7.16352 0 0 7.16352 0 16C0 23.5034 5.16608 29.7997 12.135 31.529V20.8896H8.83584V16H12.135V13.8931C12.135 8.44736 14.5997 5.9232 19.9462 5.9232C20.96 5.9232 22.7091 6.12224 23.4246 6.32064V10.7526C23.047 10.713 22.391 10.6931 21.5763 10.6931C18.953 10.6931 17.9392 11.687 17.9392 14.2707V16H23.1654L22.2675 20.8896H17.9392V31.8829C25.8618 30.9261 32.0006 24.1805 32.0006 16C32 7.16352 24.8365 0 16 0Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/getdocupdate/"
                target="_blank"
                rel="noopener noreferrer"
                className="wp-footer__social-link"
                aria-label="Instagram"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M16 2.88125C20.275 2.88125 20.7813 2.9 22.4625 2.975C24.025 3.04375 24.8688 3.30625 25.4313 3.525C26.175 3.8125 26.7125 4.1625 27.2688 4.71875C27.8313 5.28125 28.175 5.8125 28.4625 6.55625C28.6813 7.11875 28.9438 7.96875 29.0125 9.525C29.0875 11.2125 29.1063 11.7188 29.1063 15.9875C29.1063 20.2625 29.0875 20.7688 29.0125 22.45C28.9438 24.0125 28.6813 24.8563 28.4625 25.4188C28.175 26.1625 27.825 26.7 27.2688 27.2563C26.7063 27.8188 26.175 28.1625 25.4313 28.45C24.8688 28.6688 24.0188 28.9313 22.4625 29C20.775 29.075 20.2688 29.0938 16 29.0938C11.725 29.0938 11.2188 29.075 9.5375 29C7.975 28.9313 7.13125 28.6688 6.56875 28.45C5.825 28.1625 5.2875 27.8125 4.73125 27.2563C4.16875 26.6938 3.825 26.1625 3.5375 25.4188C3.31875 24.8563 3.05625 24.0063 2.9875 22.45C2.9125 20.7625 2.89375 20.2563 2.89375 15.9875C2.89375 11.7125 2.9125 11.2063 2.9875 9.525C3.05625 7.9625 3.31875 7.11875 3.5375 6.55625C3.825 5.8125 4.175 5.275 4.73125 4.71875C5.29375 4.15625 5.825 3.8125 6.56875 3.525C7.13125 3.30625 7.98125 3.04375 9.5375 2.975C11.2188 2.9 11.725 2.88125 16 2.88125ZM16 0C11.6563 0 11.1125 0.01875 9.40625 0.09375C7.70625 0.16875 6.5375 0.44375 5.525 0.8375C4.46875 1.25 3.575 1.79375 2.6875 2.6875C1.79375 3.575 1.25 4.46875 0.8375 5.51875C0.44375 6.5375 0.16875 7.7 0.09375 9.4C0.01875 11.1125 0 11.6562 0 16C0 20.3438 0.01875 20.8875 0.09375 22.5938C0.16875 24.2938 0.44375 25.4625 0.8375 26.475C1.25 27.5313 1.79375 28.425 2.6875 29.3125C3.575 30.2 4.46875 30.75 5.51875 31.1562C6.5375 31.55 7.7 31.825 9.4 31.9C11.1063 31.975 11.65 31.9937 15.9938 31.9937C20.3375 31.9937 20.8813 31.975 22.5875 31.9C24.2875 31.825 25.4563 31.55 26.4688 31.1562C27.5188 30.75 28.4125 30.2 29.3 29.3125C30.1875 28.425 30.7375 27.5313 31.1438 26.4813C31.5375 25.4625 31.8125 24.3 31.8875 22.6C31.9625 20.8938 31.9813 20.35 31.9813 16.0063C31.9813 11.6625 31.9625 11.1188 31.8875 9.4125C31.8125 7.7125 31.5375 6.54375 31.1438 5.53125C30.75 4.46875 30.2063 3.575 29.3125 2.6875C28.425 1.8 27.5313 1.25 26.4813 0.84375C25.4625 0.45 24.3 0.175 22.6 0.1C20.8875 0.01875 20.3438 0 16 0Z"
                    fill="currentColor"
                  />
                  <path
                    d="M16 7.78125C11.4625 7.78125 7.78125 11.4625 7.78125 16C7.78125 20.5375 11.4625 24.2188 16 24.2188C20.5375 24.2188 24.2188 20.5375 24.2188 16C24.2188 11.4625 20.5375 7.78125 16 7.78125ZM16 21.3312C13.0563 21.3312 10.6687 18.9438 10.6687 16C10.6687 13.0563 13.0563 10.6687 16 10.6687C18.9438 10.6687 21.3312 13.0563 21.3312 16C21.3312 18.9438 18.9438 21.3312 16 21.3312Z"
                    fill="currentColor"
                  />
                  <path
                    d="M26.4625 7.45586C26.4625 8.51836 25.6 9.37461 24.5438 9.37461C23.4813 9.37461 22.625 8.51211 22.625 7.45586C22.625 6.39336 23.4875 5.53711 24.5438 5.53711C25.6 5.53711 26.4625 6.39961 26.4625 7.45586Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/docupdate"
                target="_blank"
                rel="noopener noreferrer"
                className="wp-footer__social-link"
                aria-label="LinkedIn"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M29.6313 0H2.3625C1.05625 0 0 1.03125 0 2.30625V29.6875C0 30.9625 1.05625 32 2.3625 32H29.6313C30.9375 32 32 30.9625 32 29.6938V2.30625C32 1.03125 30.9375 0 29.6313 0ZM9.49375 27.2687H4.74375V11.9937H9.49375V27.2687ZM7.11875 9.9125C5.59375 9.9125 4.3625 8.68125 4.3625 7.1625C4.3625 5.64375 5.59375 4.4125 7.11875 4.4125C8.6375 4.4125 9.86875 5.64375 9.86875 7.1625C9.86875 8.675 8.6375 9.9125 7.11875 9.9125ZM27.2687 27.2687H22.525V19.8438C22.525 18.075 22.4937 15.7937 20.0562 15.7937C17.5875 15.7937 17.2125 17.725 17.2125 19.7188V27.2687H12.475V11.9937H17.025V14.0813H17.0875C17.7188 12.8813 19.2688 11.6125 21.575 11.6125C26.3813 11.6125 27.2687 14.775 27.2687 18.8875V27.2687Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
            </div>
          </div>

          {/* Right column: Badges */}
          <div className="wp-footer__badges">
            <img
              src={Forbes2xImg}
              alt="Forbes"
              className="wp-footer__badge wp-footer__badge--forbes"
              loading="lazy"
            />
            <a
              href="https://www.greatplacetowork.com/certified-company/7087458"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={Badge500Img}
                alt="500"
                className="wp-footer__badge wp-footer__badge--500"
                loading="lazy"
              />
            </a>
            <a
              href="https://app.vanta.com/impiricus.com/trust/7j9de7fa6wru6k8fejvxj/controls"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={SOC2LogoImg}
                alt="SOC2"
                className="wp-footer__badge wp-footer__badge--soc2"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.greatplacetowork.com/certified-company/7087458"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={GPTWBadgeImg}
                alt="Great Place to Work Certified"
                className="wp-footer__badge wp-footer__badge--gptw"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.greatplacetowork.com/certified-company/7087458"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={FortuneAccoladeImg}
                alt="Fortune — Best Workplaces in Health Care"
                className="wp-footer__badge wp-footer__badge--fortune"
                loading="lazy"
              />
            </a>
            <div className="wp-footer__badge wp-footer__badge--hipaa">
              <HipaaSealImage />
            </div>
          </div>
        </div>

        {/* ===== Bottom section (border-top + 50px margin per WP) ===== */}
        <div className="wp-footer__bottom-wrap">
          <div className="wp-footer__copyright">
            Copyright © {new Date().getFullYear()}&nbsp; DocUpdate | All Rights
            Reserved.
          </div>
          <nav className="wp-footer__legal" aria-label="Legal">
            <a
              href="https://www.docupdate.io/terms-of-service/"
              className="wp-footer__legal-link"
            >
              Terms of Service
            </a>
            <a
              href="https://www.docupdate.io/do-not-call-policy/"
              className="wp-footer__legal-link"
            >
              DNC Policy
            </a>
            <a
              href="https://www.docupdate.io/hipaa-business-associate-agreement/"
              className="wp-footer__legal-link"
            >
              HIPAA Terms
            </a>
            <a
              href="https://www.docupdate.io/ccpa-notice/"
              className="wp-footer__legal-link"
            >
              CCPA Notice
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default WPFooter;